import React, {Component} from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  accessMessage: PropTypes.oneOfType([PropTypes.element, PropTypes.oneOf([null])]),
};

const defaultProps = {
  accessMessage: null,
};

export default class AccessDenied extends Component {
  componentDidMount() {
    document.body.classList.add('page-403');
  }

  componentWillUnmount() {
    document.body.classList.remove('page-403');
  }

  render() {
    const {accessMessage} = this.props;
    let content = (
      <React.Fragment>
        <i className="icon-b icon-b-minus-circle" />
        <h1>403</h1>
        <div className="forbidden">Forbidden</div>
        <div className="message">Sorry, access to this resource is denied.</div>
      </React.Fragment>
    );
    if (accessMessage) {
      content = accessMessage;
    }

    return (
      <div className="access-denied-page">
        <div className="access-denied-page-wrapper">{content}</div>
      </div>
    );
  }
}

AccessDenied.propTypes = propTypes;
AccessDenied.defaultProps = defaultProps;
